<template>
    <div>
        <label :for="props.name" class="block text-sm tracking-wide font-bold text-tg-text">{{ props.title }}</label>
        <div class="mt-1 relative">
            <input
                :type="inputType"
                :name="props.name"
                :id="props.name"
                :placeholder="props.placeholder"
                :class="[
                    'block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-600 focus:ring-emerald-600 sm:text-sm',
                    props.toggleablePassword && props.type === 'password' && shouldShowToggleButton ? 'pr-16' : ''
                ]"
                :value="props.modelValue"
                @input="onInput"
            />
            <button
                v-if="shouldShowToggleButton"
                type="button"
                class="absolute inset-y-0 right-3 text-sm font-medium text-emerald-700 focus:outline-none"
                @click="togglePasswordVisibility"
            >
                {{ effectivePasswordVisible ? 'Скрыть' : 'Показать' }}
            </button>
        </div>
        <p v-if="props.hint" class="mt-1 text-tg-text text-xs italic">{{ props.hint }}</p>
    </div>
</template>
<script setup lang="ts">
import { InputHTMLAttributes } from '@vue/runtime-dom'
import { computed, ref } from 'vue'

const props = defineProps<{
    title: string
    hint?: string
    name: string
    type: InputHTMLAttributes['type']
    modelValue: string
    placeholder?: string
    toggleablePassword?: boolean
    passwordVisible?: boolean
    showPasswordToggle?: boolean
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

const onInput = (event: any) => {
    emit('update:modelValue', event.target.value)
}

const isPasswordVisible = ref(false)

const usesExternalPasswordVisibility = computed(() => props.passwordVisible !== undefined)

const effectivePasswordVisible = computed(() => {
    if (!props.toggleablePassword || props.type !== 'password') {
        return false
    }

    if (usesExternalPasswordVisibility.value) {
        return Boolean(props.passwordVisible)
    }

    return isPasswordVisible.value
})

const inputType = computed(() => {
    if (!props.toggleablePassword || props.type !== 'password') {
        return props.type
    }

    return effectivePasswordVisible.value ? 'text' : 'password'
})

const shouldShowToggleButton = computed(() => {
    if (!props.toggleablePassword || props.type !== 'password') {
        return false
    }

    if (props.showPasswordToggle === false) {
        return false
    }

    if (usesExternalPasswordVisibility.value) {
        return false
    }

    return true
})

const togglePasswordVisibility = () => {
    if (!shouldShowToggleButton.value) {
        return
    }

    isPasswordVisible.value = !isPasswordVisible.value
}
</script>
